export class LoginConstant {
    public static DEFAULT_LOGOUT_REDIRECT = '/home';
    public static DEFAULT_LOGIN_REDIRECT = '/home';
}
